import { render, staticRenderFns } from "./OrangeCheckbox.vue?vue&type=template&id=20d2b0f2&scoped=true&"
import script from "./OrangeCheckbox.vue?vue&type=script&lang=js&"
export * from "./OrangeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OrangeCheckbox.vue?vue&type=style&index=0&id=20d2b0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2b0f2",
  null
  
)

export default component.exports